<div class="relative block">
  <ul
    class="relative m-0 mb-[40px] flex list-none justify-around bg-white p-0 before:absolute before:top-1/2 before:bottom-0 before:left-[10%] before:z-0 before:h-[2px] before:w-4/5 before:rounded-[3px] before:bg-[#f5f5f5]"
  >
    @for (step of steps; track step; let i = $index) {
    <li class="z-1 ml-[40px] first:ml-0">
      <button
        type="button"
        [class]="circleClass(i)"
        [attr.aria-current]="i === selectedIndex ? 'step' : null"
        [disabled]="i !== selectedIndex && !isDone(i)"
        (click)="select(i)"
      >
        {{ i + 1 }}<small [class]="labelClass(i)">{{ step.label }}</small>
      </button>
    </li>
    }
  </ul>

  <div class="relative block min-h-[250px]">
    @for (step of steps; track step; let i = $index) {
    <div class="relative bg-white py-2.5 text-left" [hidden]="i !== selectedIndex">
      <ng-container [ngTemplateOutlet]="step.content"></ng-container>
    </div>
    }
  </div>
</div>
